import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
    enableProdMode,
    importProvidersFrom,
    inject,
    provideAppInitializer,
    provideZoneChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Routes, provideRouter } from '@angular/router';
import { TranslateCompiler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import {
    AuthConfigInitializerFactory,
    AuthConfigRepositoryService,
    AuthInitializerFactory,
    AuthSettingsService,
    BaseflowAuthModule,
    MAP_AUTH_CONFIG,
    authInterceptorFn,
    provideAuthentication,
} from 'baseflow-auth';
import { ToastrModule } from 'ngx-toastr';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { BaseAppInitializerFactory, ENVIRONMENT, SecureLocalStorageService, provideShared } from 'shared';

import { AppComponent } from './app/components/app/app.component';
import { MapAuthConfigFactory, TranslateLoaderFactory } from './app/factories';
import { AppSettings } from './app/models/app-settings.model';
import { AppSettingsService, WizardService } from './app/services';
import { environment } from './environments/environment';

const routes: Routes = [
    {
        path: 'tenant-invite',
        component: AppComponent,
        children: [{ path: ':tenantId', component: AppComponent }],
    },
    { path: 'account', component: AppComponent },
    { path: '**', component: AppComponent },
];

if (environment.env !== 'DEV') {
    enableProdMode();
} else {
    // Create the RxJs spy
    // create();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(
            ToastrModule.forRoot({ positionClass: 'toast-bottom-right' }),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: TranslateLoaderFactory,
                    deps: [],
                },
                compiler: {
                    provide: TranslateCompiler,
                    useClass: TranslateMessageFormatCompiler,
                },
            }),
            BaseflowAuthModule
        ),
        provideShared(),
        provideAnimationsAsync(),
        provideAppInitializer(() => AuthInitializerFactory(inject(AuthSettingsService))()),
        provideOAuthClient(),
        SecureLocalStorageService,
        provideAuthentication(),
        DatePipe,
        WizardService,
        { provide: ENVIRONMENT, useValue: environment },
        provideAppInitializer(() =>
            BaseAppInitializerFactory<AppSettings>(
                inject(TranslateService),
                inject(AppSettingsService),
                inject(ENVIRONMENT)
            )()
        ),
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptorFn])),
        provideAppInitializer(() =>
            AuthConfigInitializerFactory(
                inject(AppSettingsService),
                inject(AuthConfigRepositoryService),
                inject(MAP_AUTH_CONFIG)
            )()
        ),
        { provide: MAP_AUTH_CONFIG, useValue: MapAuthConfigFactory },
        provideRouter(routes),
    ],
}).catch((err) => console.log(err));
